import { useEffect } from 'react';

const LOCK_CLASS_NAME = 'mobile-overlay-open';
let lockCount = 0;
let originalStyles = null;

const addLockClass = () => {
    document.documentElement.classList.add(LOCK_CLASS_NAME);
    document.body.classList.add(LOCK_CLASS_NAME);
};

const removeLockClass = () => {
    document.documentElement.classList.remove(LOCK_CLASS_NAME);
    document.body.classList.remove(LOCK_CLASS_NAME);
};

const lockBodyScroll = () => {
    if (typeof window === 'undefined') {
        return;
    }

    const html = document.documentElement;
    const body = document.body;
    const scrollbarWidth = Math.max(window.innerWidth - html.clientWidth, 0);
    const shouldCompensateScrollbar = !window.matchMedia('(max-width: 768px)').matches;

    originalStyles = {
        htmlOverflow: html.style.overflow,
        htmlOverscrollBehavior: html.style.overscrollBehavior,
        bodyOverflow: body.style.overflow,
        bodyOverscrollBehavior: body.style.overscrollBehavior,
        bodyPaddingRight: body.style.paddingRight,
    };

    html.style.overflow = 'hidden';
    html.style.overscrollBehavior = 'none';
    body.style.overflow = 'hidden';
    body.style.overscrollBehavior = 'none';

    // Compensate only on larger viewports to avoid mobile card/grid width jumps.
    if (shouldCompensateScrollbar && scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
    }
};

const unlockBodyScroll = () => {
    if (typeof window === 'undefined') {
        return;
    }

    const html = document.documentElement;
    const body = document.body;

    if (!originalStyles) {
        return;
    }

    html.style.overflow = originalStyles.htmlOverflow;
    html.style.overscrollBehavior = originalStyles.htmlOverscrollBehavior;
    body.style.overflow = originalStyles.bodyOverflow;
    body.style.overscrollBehavior = originalStyles.bodyOverscrollBehavior;
    body.style.paddingRight = originalStyles.bodyPaddingRight;

    originalStyles = null;
};

const useBodyScrollLock = (isLocked) => {
    useEffect(() => {
        if (!isLocked || typeof document === 'undefined') {
            return undefined;
        }

        lockCount += 1;
        if (lockCount === 1) {
            addLockClass();
            lockBodyScroll();
        }

        return () => {
            lockCount = Math.max(lockCount - 1, 0);
            if (lockCount === 0) {
                removeLockClass();
                unlockBodyScroll();
            }
        };
    }, [isLocked]);
};

export default useBodyScrollLock;


